module.exports = __webpack_public_path__ + "static/logo-us-coc-63af789d3e0f64b8b0126ef7a6349e02.png";